import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { LINKS, relPath } from '../../../../../Routs/config'
import OrderQuotationTitles from './OrderQuotationTitles'
import OrderQuotationDetails from './OrderQuotationDetails'

type Props = {
}

const OrderQuotationMain = (props: Props) => {

  return (
    <Routes>
      <Route index element={<OrderQuotationTitles/>} />
      <Route path={relPath(LINKS.orders.quotation.detailsById, LINKS.orders.quotation.mainUrl)} element={<OrderQuotationDetails/>} />
    </Routes>
  )
}

export default OrderQuotationMain